import { Directive, ElementRef, HostListener } from '@angular/core';

/** Date / month fields open their calendar on a click anywhere in the field, not only on the calendar icon. */
@Directive({
  selector: 'input[type=date], input[type=month]'
})
export class DatePickerOpenDirective {

  constructor(private el: ElementRef) { }

  @HostListener('click')
  open() {
    const input = this.el.nativeElement as any;
    if (input.disabled || input.readOnly || typeof input.showPicker !== 'function') return;
    try { input.showPicker(); } catch (e) { /* already open: the browser's own behaviour applies */ }
  }
}
